export const formRegex = {
    nameRegex: /^$|[A-Za-zА-Яа-я ]+$/,
    cityRegex: /^$|[А-Яа-я -]+$/,
    phoneInputRegex: /^$|[+\d ()-]+$/,
    phoneValidationRegex: /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/,
    mailInputRegex: /^$|[\-A-Za-z\.\@]+$/,
    mailValidationRegex: /^$|\S+@\S+/,
};
